import { reducer as userSessionReducer } from "@talentech/bff-login";
import { combineReducers } from "redux";
import { customerApi } from "./customer.api";

const reducer = combineReducers({
  userSession: userSessionReducer,
  customerApi: customerApi.reducer,
});

export default reducer;
